export default "__VITE_ASSET__UndlmgmH__"